import React from "react";
import { StyledText } from './StyledComponents';
import { StyledButton } from '../../../components/Elements/StyledComponents'

export const SelectedCandidates = ({ list, text, eventTime, type, onDelete }) => (
    <StyledText>
        <span>{text}</span>
        {list.length ?
            list.map(item =>
                <StyledButton
                    key={item}
                    variant="danger"
                    onClick={() => onDelete(eventTime, type, item)}
                >
                    {item}
                </StyledButton>
            )
            : "not selected"}
    </StyledText>
)